import React from "react";
import classNames from "classnames";
import SimpleCard from "../../SimpleCard";

const Card = (props) => {
  const { className } = props;

  const classes = classNames(className, {
    cards: true,
  });

  return (
    <div className={classes}>
      <button style={{ width: "6rem" }} type="button" className="btn btn btn-link">
        <i className="fa fa-plus-circle"></i> <span>Add Loan</span>
      </button>

      <SimpleCard visible={3} spacing={6} ratio={0.625}>
        <div style={{ background: "#aaa", width: "100%", height: "100%" }} />
      </SimpleCard>
    </div>
  );
};

export default Card;
